export const ADD_TO_EXISTING_ACTION = 'existing'
export const CREATE_AND_ADD_ACTION = 'create'
export const STATE_INITIAL = 'initial'
export const STATE_WITH_GROUPS = 'with_groups'
export const STATE_WITH_NO_GROUPS = 'no_groups'
export const USER_GROUPS_PAGE_SIZE = 20
